import api from "./http";

export const signup = (payload) => api.post("/auth/signup", payload);

// export const login = (payload) => api.post("/auth/login", payload);

export const login = (payload) => {
  // 1. Create the Form Data container
  const params = new URLSearchParams();
  
  // 2. Map 'email' from your React form to 'username' for FastAPI
  params.append("username", payload.email); 
  params.append("password", payload.password);

  // 3. Send as form-urlencoded
  return api.post("/auth/login", params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

export const getCurrentBuilder = () => api.get("/auth/me");

export const updateBuilderProfile = (payload) => api.put("/auth/me", payload);

export const getWhatsAppStatus = () => api.get("/auth/whatsapp-status");

